import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Renders the selected variant's ingredients list (custom.ingredients_list)
 * and re-syncs on variant change. Same morph-from-section-HTML pattern as
 * variant-metafields-component and variant-weight-component.
 */
class VariantIngredientsComponent extends Component {
  /** @type {HTMLElement | null} */
  #target = null;

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    if (!target) return;
    this.#target = target;
    target.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#target) {
      this.#target.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
      this.#target = null;
    }
  }

  /**
   * @param {CustomEvent<{ data?: { html?: Document } }>} event
   */
  handleVariantUpdate = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    const blockId = this.dataset.blockId;
    if (!blockId) return;

    const next = html.querySelector(
      `variant-ingredients-component[data-block-id="${CSS.escape(blockId)}"]`
    );
    if (!next) return;

    const nextContent = next.querySelector('.variant-ingredients__content');
    const currentContent = this.querySelector('.variant-ingredients__content');
    if (nextContent && currentContent) {
      currentContent.innerHTML = nextContent.innerHTML;
    }

    this.classList.toggle(
      'variant-ingredients--empty',
      next.classList.contains('variant-ingredients--empty')
    );
  };
}

if (!customElements.get('variant-ingredients-component')) {
  customElements.define('variant-ingredients-component', VariantIngredientsComponent);
}
